var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',{staticClass:"decision-tree pa-0"},_vm._l((_vm.filteredAttributes),function(attribute,index){return _c('v-list-group',{directives:[{name:"show",rawName:"v-show",value:(attribute.in_decision_tree),expression:"attribute.in_decision_tree"}],key:attribute.slug,attrs:{"value":_vm.currentAttribute === index},on:{"click":function($event){_vm.currentAttribute = index}}},[_c('v-list-tile',{staticClass:"decision-tree__category",attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('span',{staticClass:"decision-tree__step-title"},[_c('span',[_vm._v("Select "+_vm._s(attribute.name))]),_vm._v(" "),(
									attribute.units &&
										attribute.name != 'Lifting Capacity'
								)?_c('span',[_vm._v("("+_vm._s(attribute.units)+")")]):_vm._e()]),_vm._v(" "),(
								_vm.selectedAttributes[attribute.slug] !==
									null &&
									_vm.selectedAttributes[attribute.slug] !==
										undefined
							)?_c('span',{staticClass:"decision-tree__selection"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.convertValue(
									_vm.selectedAttributes[attribute.slug]
								))+"\n\t\t\t\t\t\t\t"),(
									_vm.selectedAttributes[attribute.slug] ===
										'Hoist Carrier'
								)?_c('span',[_vm._v("Components")]):_vm._e(),_vm._v(" "),(
									attribute.units &&
										attribute.name == 'Lifting Capacity'
								)?_c('span',{staticStyle:{"text-transform":"capitalize"},domProps:{"textContent":_vm._s(
									parseFloat(
										_vm.selectedAttributes[attribute.slug]
									) > 1
										? attribute.units
										: attribute.units_singular
								)}}):_vm._e()]):_vm._e()])],1),_vm._v(" "),(
						_vm.selectedAttributes[attribute.slug] !== null &&
							_vm.selectedAttributes[attribute.slug] !== undefined
					)?_c('v-list-tile-action',{on:{"click":function($event){$event.stopPropagation();return _vm.resetAttribute(attribute.slug)}}},[_c('div',{staticClass:"v-icon"},[_c('fa-icon',{attrs:{"icon":['fal', 'times'],"size":"xs"}})],1)]):_vm._e()],1),_vm._v(" "),_vm._l((attribute.values),function(value){return _c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAttributeDisabled(attribute.slug, value)),expression:"!isAttributeDisabled(attribute.slug, value)"}],key:value,staticClass:"decision-tree__value",class:{
					'decision-tree__value--disabled': _vm.isAttributeDisabled(
						attribute.slug,
						value
					)
				},attrs:{"no-action":""},on:{"click":function($event){return _vm.selectAttribute(attribute.slug, value)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.convertValue(value))+"\n\t\t\t\t\t\t\t"),(
									attribute.units &&
										attribute.name == 'Lifting Capacity'
								)?_c('span',{staticStyle:{"text-transform":"capitalize"},domProps:{"textContent":_vm._s(
									parseFloat(value) > 1
										? attribute.units
										: attribute.units_singular
								)}}):_vm._e()])])],1)],1)})],2)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }